main.home {
  display: grid;
  grid-area: main !important;
  padding: var(--cxy-spacing-4);
  grid-template-areas: 'hero' 'content';
  grid-template-rows: 690px auto;
}

[data-fpsm-theme='gazzetta'] {
  main.home {
    grid-template-rows: 620px auto;
  }

  @media (max-width: 800px) {
    main.home {
      grid-template-rows: auto auto;
    }
  }
}

@media (min-width: 801px) {
  main.home {
    grid-template-rows: 500px auto;
  }
}
@media (min-width: 799px) {
  [data-fpsm-theme='gazzetta'] {
    main.home {
      grid-template-rows: 600px auto;
    }
  }
}
@media (min-width: 801px) {
  [data-fpsm-theme='gazzetta'] {
    main.home {
      grid-template-rows: 500px auto;
    }
  }
}
@media (min-width: 1025px) {
  [data-fpsm-theme='gazzetta'] {
    main.home {
      grid-template-rows: 630px auto;
    }
  }
}
@media (min-width: 1200px) {
  [data-fpsm-theme='gazzetta'] {
    main.home {
      grid-template-rows: 530px auto;
    }
  }
}

main.home.home--narrow {
  max-width: 1232px;
}

main.home.home--uk {
  grid-template-rows: 375px auto;
}

@media (min-width: 801px) {
  main.home.home--uk {
    grid-template-rows: 390px auto;
  }
}

main.home.home--uk .heroImage {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: var(--cxy-z-index-hidden);
  width: 100%;
  height: auto;
}

@media (min-width: 801px) {
  main.home.home--uk .heroImage {
    bottom: -40px;
    left: 25%;
    display: block;
  }
}

@media (min-width: 801px) {
  main.home.home--uk .heroImage {
    display: flex;
    top: -120px;
  }
}

main.home.home--uk .heroImage img {
  clip-path: none;
}

[data-template*='plus'] .gradient {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: var(--cxy-z-index-hidden);
  background-image:
    radial-gradient(
      farthest-corner at 10% 30%,
      color-mix(in srgb, var(--cxy-color-container-default), transparent 1%),
      transparent 60%
    ),
    radial-gradient(
      farthest-corner at 80% 30%,
      color-mix(in srgb, var(--cxy-color-green-500), transparent 1%),
      transparent 60%
    ),
    radial-gradient(
      farthest-side at 30% 100%,
      color-mix(in srgb, var(--cxy-color-purple-500), transparent 5%),
      transparent 80%
    ),
    radial-gradient(
      farthest-corner at 100% 160%,
      color-mix(in srgb, var(--cxy-color-red), transparent 1%),
      transparent 60%
    );
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

[data-template*='plus'] .hero {
  grid-area: hero;
  position: relative;
  overflow: hidden;
}

@media (min-width: 801px) {
  [data-template*='plus'] .hero {
    overflow: visible;
    margin-block-end: var(--cxy-spacing-8);
  }
}

[data-template*='plus'] .hero .heroContent {
  padding-inline: var(--cxy-spacing-4);
}

[data-template*='plus'] .hero .textContainer {
  max-width: 312px;
}

@media (max-width: 1025px) {
  [data-template*='plus'] .hero .textContainer .heroPriceCardWrapper {
    display: none;
  }
}

@media (max-width: 801px) {
  [data-fpsm-theme='gazzetta'] .hero .textContainer {
    max-width: unset;
  }
}

@media (min-width: 1025px) {
  [data-template*='plus'] .hero .textContainer .heroPriceCardWrapper {
    display: flex;
    gap: var(--cxy-spacing-4);
  }
}

@media (min-width: 801px) {
  [data-template*='plus'] .hero .textContainer {
    max-width: 450px;
  }
}

@media (min-width: 1025px) {
  [data-template*='plus'] .hero .textContainer {
    max-width: 600px;
  }
}

@media (min-width: 1200px) {
  [data-template*='plus'] .hero .textContainer {
    max-width: 750px;
  }
}

@media (min-width: 801px) {
  [data-template*='plus'] .hero .textContainer.textContainer--narrow {
    max-width: 600px;
  }
}

[data-template*='plus'] .title {
  color: var(--cxy-color-brand);
  font-family: var(--cxy-font-family-futura);
  text-transform: uppercase;
  font-size: var(--cxy-fontSize-xxl);
  line-height: var(--cxy-lineHeight-xl);
  font-weight: var(--cxy-fontWeight-extraBold);
}

[data-template*='plus'] .title span {
  white-space: nowrap;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  font-family: inherit;
}

@media (min-width: 801px) {
  [data-template*='plus'] .title {
    margin-block-start: 30px;
    font-size: 60px;
    line-height: 64px;
  }
}

[data-template*='plus'] .heroButton {
  font-size: var(--cxy-fontSize-l);
  width: 100%;
}

@media (min-width: 801px) {
  [data-template*='plus'] .heroButton {
    font-size: var(--cxy-fontSize-xl);
    width: 280px;
  }
}

[data-template*='plus'] .heroImage {
  display: flex;
  justify-content: center;
  height: 490px;
  margin-block-start: var(--cxy-spacing-6);
}

@media (min-width: 801px) {
  [data-template*='plus'] .heroImage {
    margin-block-start: 0;
    position: absolute;
    top: 0;
    right: -85px;
    width: 525px;
    height: auto;
  }

  [data-template*='plus'] .heroImage img {
    clip-path: inset(50px 30px 205px 90px);
  }
}

[data-template*='plus'][data-fpsm-theme='gazzetta'] .heroImage img {
  object-view-box: rect(10% 80% 50% 20%);
  object-fit: scale-down;
}

@media (min-width: 520px) {
  [data-template*='plus'][data-fpsm-theme='gazzetta'] .heroImage img {
    object-view-box: rect(5% 80% 50% 20%);
    object-fit: scale-down;
  }
}

@media (min-width: 801px) {
  [data-template*='plus'][data-fpsm-theme='gazzetta'] .heroImage {
    margin-block-start: 0;
  }

  [data-template*='plus'][data-fpsm-theme='gazzetta'] .heroImage img {
    object-view-box: unset;
    object-fit: unset;
  }
}
@media (min-width: 1024px) {
  [data-template*='plus'][data-fpsm-theme='gazzetta'] .heroImage {
    margin-block-start: 130px;
  }
}

@media (min-width: 1200px) {
  [data-template*='plus'][data-fpsm-theme='gazzetta'] .heroImage {
    margin-block-start: 30px;
  }
}

@media (min-width: 1100px) {
  [data-template*='plus'] .heroImage {
    right: 0;
  }
}

[data-template*='plus'] .subtitle {
  color: var(--cxy-color-content-default);
  margin-block: var(--cxy-spacing-3);
  font-size: var(--cxy-fontSize-m);
  font-weight: var(--cxy-fontWeight-semiBold);
  line-height: var(--cxy-lineHeight-l);
}

@media (min-width: 801px) {
  [data-template*='plus'] .subtitle {
    font-size: var(--cxy-fontSize-xl);
    line-height: var(--cxy-lineHeight-xl);
  }
}

[data-template*='plus'] .productButton {
  margin-block-start: var(--cxy-spacing-4);
}

@media (min-width: 801px) {
  [data-template*='plus'] .productButton {
    width: 248px;
  }
}

[data-template*='plus'] .productList {
  flex-direction: column;
}

@media (min-width: 801px) {
  [data-template*='plus'] .productList {
    flex-direction: row;
  }
}

[data-template*='plus'] .section {
  margin-block-start: 60px;
}

[data-template*='plus'] .sectionTitle {
  color: var(--cxy-color-brand);
  font-size: 38px;
  font-weight: var(--cxy-fontWeight-bold);
  line-height: 40px;
  margin-block-end: var(--cxy-spacing-6);
  text-align: center;
}

[data-template*='plus'] .sectionDescription {
  color: var(--cxy-color-content-default);
  font-size: var(--cxy-fontSize-m);
  font-weight: var(--cxy-fontWeight-medium);
  line-height: 18px;
  text-align: center;
  margin-block-end: var(--cxy-spacing-7);
}

[data-template*='plus'] .priceCardWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--cxy-spacing-4);
}

@media (min-width: 801px) {
  [data-template*='plus'] .priceCardWrapper {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
}

@media (min-width: 1025px) {
  [data-template*='plus'] .priceCardWrapper {
    flex-wrap: nowrap;
    justify-content: center;
  }
}

[data-template*='plus'] .planList {
  padding-bottom: var(--cxy-spacing-8);
  display: flex;
  justify-content: center;
}

[data-template*='plus'] .accordionContent + .accordionContent {
  margin-block-start: var(--cxy-spacing-5);
}

[data-template*='plus'] .link {
  font-weight: var(--cxy-fontWeight-bold);
  font-size: inherit;
  line-height: inherit;
  text-decoration: underline;
}

[data-template*='plus'] .link,
[data-template*='plus'] .link:hover,
[data-template*='plus'] .link:visited {
  color: var(--cxy-color-content-default);
}

[data-template*='plus'] .tertiaryButton {
  text-transform: uppercase;
}

[data-template*='plus'] .tertiaryButton:hover {
  opacity: 1;
  background-color: var(--cxy-color-container-white);
  color: var(--cxy-color-content-dark);
}

.drawerContent {
  background: linear-gradient(180deg, #4e1563 0%, #342d9b 100%);
  height: 80vh;
  max-height: calc(100vh - 80px);
  z-index: var(--cxy-z-index-overlay);
}

@media (min-height: 800px) {
  .drawerContent {
    height: 70vh;
  }
}

@media (min-height: 900px) {
  .drawerContent {
    height: 65vh;
  }
}

.drawerContent .pricingSection {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--cxy-spacing-8) var(--cxy-spacing-4);
  gap: var(--cxy-spacing-2);
}

.drawerContent .pricingSection .priceSelection {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.05);
  width: 100%;
  padding: var(--cxy-spacing-5);
  border-radius: var(--cxy-border-radius-m);
}

.drawerContent .pricingSection .priceSelection .term {
  font-size: var(--cxy-fontSize-m);
  color: var(--cxy-color-content-default);
  line-height: var(--cxy-lineHeight-m);
}

.drawerContent .pricingSection .priceSelection .bestValue {
  font-size: var(--cxy-fontSize-m);
  font-weight: var(--cxy-fontWeight-bold);
  color: var(--cxy-color-brand);
  line-height: var(--cxy-lineHeight-m);
}

.drawerContent .pricingSection .priceSelection .price {
  font-weight: var(--cxy-fontWeight-bold);
  height: 50px;
}

.drawerContent .pricingSection .priceSelection .price .monthlyCost {
  font-size: 37px;
}

.drawerContent .pricingSection .priceSelection .paid {
  font-weight: var(--cxy-fontWeight-bold);
  margin-bottom: var(--cxy-spacing-3);
}

.drawerContent .pricingSection .priceSelection .subscribeButton {
  height: 48px;
  width: 90%;
  text-transform: uppercase;
}

.drawerContent .pricingSection .subscribeOptions {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.drawerContent .bestValueBorder {
  position: relative;
  border: 2px solid var(--cxy-color-content-default);
  border-radius: var(--cxy-border-radius-l);
  padding: var(--cxy-spacing-4);
}

.drawerContent .bestValueTag {
  position: absolute;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--cxy-color-content-default);
  color: var(--cxy-color-content-dark);
  font-size: var(--cxy-fontSize-s);
  font-weight: var(--cxy-fontWeight-bold);
  padding: var(--cxy-spacing-1) var(--cxy-spacing-3);
  border-radius: 50px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  white-space: nowrap;
}

.drawerButton {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 70px;
  border-radius: 0;
  background-color: var(--cxy-color-brand);
  border: 0;
  color: var(--cxy-color-content-dark);
  font-size: var(--cxy-fontSize-m);
  font-weight: var(--cxy-fontWeight-bold);
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.14);
}

@media (min-width: 801px) {
  .drawerButton {
    display: none;
  }
}

.drawerButton.close {
  background-color: var(--cxy-color-container-default);
  color: var(--cxy-color-content-default);
}

/* ========================================
   Theme Overrides
   ======================================== */
/* WhoScored theme overrides */
@media (min-width: 801px) {
  [data-fpsm-theme='whoscored'] .title {
    font-size: 45px;
  }
}

[data-fpsm-theme='whoscored'] .drawerContent {
  background: #000000;
}

@media (min-height: 800px) {
  [data-fpsm-theme='whoscored'] .drawerContent {
    height: 40vh;
  }
}

@media (min-height: 900px) {
  [data-fpsm-theme='whoscored'] .drawerContent {
    height: 35vh;
  }
}

[data-fpsm-theme='whoscored'] .drawerButton.close {
  background-color: #ffffff;
  color: #000000;
}

/* Gazzetta theme overrides */
[data-fpsm-theme='gazzetta'] {
  .title {
    text-transform: unset;
  }

  .gradient {
    display: none;
  }

  .tertiaryButton:hover {
    background-color: var(--cxy-color-brand);
    opacity: 0.8;
  }

  .productCards {
    flex-direction: column-reverse;

    @media (min-width: 800px) {
      flex-direction: row;
    }
  }

  .drawerContent {
    background: var(--cxy-color-pink-400);
  }

  .drawerButton {
    background-color: var(--cxy-color-pink-900);
    color: var(--cxy-color-white);
  }

  .planList {
    ul {
      @media (min-width: 800px) {
        flex-direction: row !important;
        flex-wrap: wrap;
      }
    }

    [class*='iconWrapper'] {
      background-color: var(--cxy-color-pink-900);
    }

    svg {
      color: var(--cxy-color-white);
    }
  }

  .heroImage {
    @media (max-width: 800px) {
      display: none;
    }
  }

  .heroMobileCta {
    display: none;

    @media (max-width: 800px) {
      display: flex;
      margin-block-start: var(--cxy-spacing-4);
      margin-block-end: var(--cxy-spacing-4);
      width: 100%;
    }
  }
}
